import { Grid, Typography } from "@mui/material";

interface StatBoxProps {
  title: string;
  value: number | string;
}

const StatBox = ({ title, value }: StatBoxProps) => {
  const theme = {
    width: "100%",
    paddingBottom: "20px",
    paddingTop: "20px",
    borderRadius: "10px",
    backgroundColor: "white !important",
    minHeight: "50px",
    paddingLeft: "16px",
  };

  return (
    <Grid item container direction={"column"} sx={theme}>
      <Grid item>
        <Typography variant="body1">{title}</Typography>
      </Grid>
      <Grid item>
        <Typography variant="statTitle">{value}</Typography>
      </Grid>
    </Grid>
  );
};

export default StatBox;
